export default __webpack_public_path__ + "static/media/q2_step3.6e678c43.png";